import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const dashboardOverviewSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.DASHBOARD_HEADER}`,
        popover: {
            title: "Dashboard Header",
            description:
                "This displays the opponent and final score. " +
                "By default, it always loads the most recent Vålerenga game.",
            side: "bottom",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.DASHBOARD_AI_SUMMARY}`,
        popover: {
            title: "AI Summary",
            description:
                "Click here to generate or read an AI-powered summary of the game. " +
                "You can provide feedback on its accuracy to help train the AI for better future insights.",
            side: "bottom",
            align: "end",
        },
    },
    {
        element: `#${ONBOARDING_IDS.DASHBOARD_MATCH_SELECT}`,
        popover: {
            title: "Match Select",
            description:
                "Use this tool to change your dataset. You can filter the dashboard to show a specific match, " +
                "aggregate data across a set of games, or view entire tournaments.",
            side: "bottom",
            align: "end",
        },
    },
    {
        element: `#${ONBOARDING_IDS.DASHBOARD_NAV}`,
        popover: {
            title: "Dashboard Navigation",
            description: "Use these tabs to switch between different data visualizations for your selected matches.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.DASHBOARD_LEADERBOARD}`,
        popover: {
            title: "Player Leaderboard",
            description:
                "Get the immediate rankings. This shows players sorted by their total points " +
                "for the currently selected match or timeframe.",
            side: "right",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.DASHBOARD_BADGES}`,
        popover: {
            title: "Achievement Badges",
            description:
                "See which performance milestones were unlocked. You can toggle between " +
                "individual player awards and overall team achievements.",
            side: "left",
            align: "start",
        },
    },
];
